import {Injectable} from '@angular/core';
import {EntityClass} from '../../entity.class';
import {entityDecorator} from '../../entity.decorator';

@Injectable()
@entityDecorator({
  url: 'api/mentalseal/v1/admin/department/managev2',
  name: 'department',
  protobufJSON: require('assets/protobuf/ownerManage/ownerManage.json'),
  protobufModule: 'Department'
})
export class OrganizationDptAdminService extends EntityClass {

}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/entity-base/entity-service/ownerRoleManage/organization-dpt-admin.service.ts